import React, { useEffect, useRef, useState } from 'react';
import { Eraser } from 'lucide-react';

export default function SignaturePad({ value, onChange, disabled, testid }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(!value);

  useEffect(() => {
    const cv = ref.current;
    const ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, cv.width, cv.height);
    if (value) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, cv.width, cv.height);
      img.src = value;
    }
    setEmpty(!value);
  }, [value]);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [(e.clientX - r.left) * (ref.current.width / r.width), (e.clientY - r.top) * (ref.current.height / r.height)];
  };
  const down = (e) => {
    if (disabled) return;
    drawing.current = true;
    ref.current.setPointerCapture(e.pointerId);
    const ctx = ref.current.getContext('2d');
    ctx.lineWidth = 2.4; ctx.lineCap = 'round'; ctx.strokeStyle = '#0f172a';
    ctx.beginPath(); ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext('2d');
    ctx.lineTo(...pos(e)); ctx.stroke(); setEmpty(false);
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL('image/png'));
  };

  return (
    <div>
      <div className={`relative rounded-lg border-2 border-dashed ${disabled ? 'border-slate-200 bg-slate-50' : 'border-slate-300 bg-white'}`}>
        <canvas ref={ref} width={600} height={180} className="w-full h-[120px] touch-none cursor-crosshair" data-testid={testid}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} />
        {empty && <span className="absolute inset-0 flex items-center justify-center text-xs text-slate-400 pointer-events-none">Sign here</span>}
      </div>
      {!disabled && !empty && (
        <button type="button" onClick={() => onChange('')} className="mt-1 inline-flex items-center gap-1 text-xs text-slate-500 hover:text-rose-600" data-testid={`${testid}-clear`}>
          <Eraser className="w-3 h-3" />Clear signature
        </button>
      )}
    </div>
  );
}
